import { FC } from "react";

import { useTranslation } from "next-i18next";

import { Divider, FullWidthVStack } from "@components/common";
import responsiveStyle from "@lib/theme/responsiveStyle";

import { OrderFields, OrderStep } from "../../constants";
import useClearConflictingReceiverData from "../../hooks/common/useClearConflictingReceiverData";
import useClearConflictingSenderData from "../../hooks/common/useClearConflictingSenderData";
import useCommonOrderSideEffects from "../../hooks/common/useCommonOrderSideEffects";
import usePackageInfoSideEffects from "../../hooks/packageInfo/usePackageInfoSideEffects";
import OrderFooter from "../common/OrderFooter";
import OrderForm from "../common/OrderForm";
import OrderPrice from "../common/OrderPrice";
import CountrySelect from "./CountrySelect";
import DeliveryMethod from "./DeliveryMethod";
import PackageSize from "./PackageSize";
import ParcelWeight from "./ParcelWeight";

const PackageInfo: FC = () => {
  const { t } = useTranslation();

  // Following hooks causes side effects in form
  // (controls data loading, default data selection, dependencies between fields, etc.)
  useCommonOrderSideEffects(OrderStep.PackageInfo);
  usePackageInfoSideEffects();

  const { handleStartingCountryChange } = useClearConflictingSenderData();
  const { handleDestinationCountryChange, handleDeliveryMethodChange } = useClearConflictingReceiverData();

  return (
    <OrderForm style={{ height: "100%" }}>
      <FullWidthVStack spacing={responsiveStyle({ mobile: "1.625rem", desktop: "2.25rem" })} height="100%">
        <FullWidthVStack spacing={responsiveStyle({ mobile: "1.625rem", desktop: "2.25rem" })} flex="1">
          <CountrySelect
            label={t("order-package-starting_country")}
            name={OrderFields.STARTING_COUNTRY}
            onChange={handleStartingCountryChange}
          />
          <CountrySelect
            label={t("order-package-destination_country")}
            name={OrderFields.DESTINATION_COUNTRY}
            onChange={handleDestinationCountryChange}
          />
          <PackageSize name={OrderFields.PACKAGE_SIZE} />
          <DeliveryMethod name={OrderFields.DELIVERY_METHOD} onChange={handleDeliveryMethodChange} />
          <ParcelWeight name={OrderFields.PACKAGE_WEIGHT} />
          <Divider />
          <OrderPrice withPromo={false} />
        </FullWidthVStack>
        <OrderFooter currentStep={OrderStep.PackageInfo} />
      </FullWidthVStack>
    </OrderForm>
  );
};

export default PackageInfo;
